export enum OcppStatusEnum {
  undefined = 'undefined',
  available = 'available',
  preparing = 'preparing',
  charging = 'charging',
  occupied = 'occupied',
  suspendedEVSE = 'suspendedEVSE',
  suspendedEV = 'suspendedEV',
  finishing = 'finishing',
  reserved = 'reserved',
  unavailable = 'unavailable',
  faulted = 'faulted',
  provisioned = 'provisioned',
}

export type OcppStatus =
  | 'UNDEFINED'
  | 'AVAILABLE'
  | 'PREPARING'
  | 'CHARGING'
  | 'OCCUPIED'
  | 'SUSPENDEDEVSE'
  | 'SUSPENDEDEV'
  | 'FINISHING'
  | 'RESERVED'
  | 'UNAVAILABLE'
  | 'FAULTED'
  | 'PROVISIONED';
